import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const LogBookSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="logBook-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 18"
        data-testid="logBook-svg"
      >
        <defs>
          <path
            id="logbook"
            d="M16.906 19c.468 0 .844-.376.844-.844v-.562c0-.264-.123-.503-.313-.658-.148-.541-.148-2.084 0-2.626.19-.151.313-.39.313-.654V1.844c0-.468-.376-.844-.844-.844H5.375C3.512 1 2 2.512 2 4.375v11.25C2 17.488 3.512 19 5.375 19h11.531zM14.164 6.625H6.711c-.116 0-.211-.095-.211-.21V5.71c0-.116.095-.211.21-.211h7.454c.116 0 .211.095.211.211v.703c0 .116-.095.211-.21.211zm0 2.25H6.711c-.116 0-.211-.095-.211-.21V7.96c0-.116.095-.211.21-.211h7.454c.116 0 .211.095.211.211v.703c0 .116-.095.211-.21.211zm1.245 7.875H5.375c-.622 0-1.125-.503-1.125-1.125 0-.619.506-1.125 1.125-1.125h10.034c-.067.601-.067 1.649 0 2.25z"
          />
        </defs>
        <g fill="none" transform="translate(-2 -1)">
          <use fill="#0B0B0B" href="#logbook" />
          <use fill="#070B16" href="#logbook" />
        </g>
      </svg>
    </StyledContainer>
  );
};

export default LogBookSVG;
